if (!customElements.get('product-card-variant-select')) {
class ProductCardVariantSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.addEventListener('change', this.handleVariantChange.bind(this));
    this.addEventListener('touchstart', this.handleTouchStart.bind(this));
    this.addEventListener('mousedown', this.handleMouseDown.bind(this));
  }

  handleTouchStart(event) {
    if (window.innerWidth <= 767.98) {
      const select = event.target;
      const dropdown = select.closest('.product-card-variants__dropdown');
      if (dropdown) {
        const rect = dropdown.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetY = rect.top + scrollTop - (window.innerHeight / 2) + (rect.height / 2);
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }
    }
  }

  handleMouseDown(event) {
    if (window.innerWidth > 767.98) {
      return;
    }
    this.handleTouchStart(event);
  }

  handleVariantChange(event) {
    const select = event.target;
    const dropdown = select.closest('.product-card-variants__dropdown');
    if (!dropdown) return;

    const selectedOption = select.options[select.selectedIndex];
    const variantId = selectedOption.value;
    const variantIcon = selectedOption.dataset.variantIcon;
    const variantText = selectedOption.dataset.variantText || selectedOption.textContent;

    const iconContainer = dropdown.querySelector('.product-card-variants__icon');
    const textContainer = dropdown.querySelector('.product-card-variants__text');
    const iconsPreload = dropdown.querySelector('.product-card-variants__icons-preload');

    if (!textContainer || !iconsPreload) return;

    // Update icon
    if (variantIcon && iconContainer) {
      const preloadedIcon = iconsPreload.querySelector(`[data-variant-icon-name="${variantIcon}"]`);
      if (preloadedIcon) {
        iconContainer.innerHTML = preloadedIcon.innerHTML;
      } else {
        iconContainer.innerHTML = '';
      }
    } else if (iconContainer) {
      iconContainer.innerHTML = '';
    }

    // Update displayed text
    textContainer.textContent = variantText;

    // Find and update the form
    this.updateProductForm(dropdown, variantId, selectedOption);
  }

  updateProductForm(dropdown, variantId, selectedOption) {
    // Find the form - try multiple approaches for better compatibility
    const actionsWrapper = dropdown.closest('.product-card__actions-wrapper');
    let form = null;
    
    if (actionsWrapper) {
      form = actionsWrapper.querySelector('form[data-type="add-to-cart-form"]') || 
             actionsWrapper.querySelector('form.product-card__atc-form') ||
             actionsWrapper.querySelector('form');
    }
    
    // If form not found in actionsWrapper, try finding it in the product card
    if (!form) {
      const productCard = dropdown.closest('.product-card');
      if (productCard) {
        form = productCard.querySelector('form[data-type="add-to-cart-form"]') || 
               productCard.querySelector('form.product-card__atc-form') ||
               productCard.querySelector('form');
      }
    }
    
    if (!form) return;

    // Update variant ID in form
    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = variantId;
    }

    // Update button price and availability
    const submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton) return;

    const variantPrice = selectedOption.dataset.variantPrice;
    const variantAvailable = selectedOption.dataset.variantAvailable === 'true';
    
    submitButton.dataset.variantId = variantId;
    submitButton.dataset.variantPrice = variantPrice;
    submitButton.dataset.variantAvailable = variantAvailable;

    if (variantAvailable) {
      this.updateButtonForAvailableVariant(submitButton, variantPrice);
    } else {
      this.updateButtonForUnavailableVariant(submitButton);
    }
  }

  updateButtonForAvailableVariant(button, variantPrice) {
    button.removeAttribute('disabled');
    const textDesktop = button.querySelector('.btn__text--desktop');
    const textMobile = button.querySelector('.btn__text--mobile');
    
    if (!variantPrice || !window.FoxTheme || !window.FoxTheme.Currency) return;

    const priceFormatted = window.FoxTheme.Currency.formatMoney(
      parseInt(variantPrice),
      window.FoxTheme.settings.moneyFormat
    );
    
    // Update desktop text
    if (textDesktop) {
      const priceEl = textDesktop.querySelector('.product-card__atc-price');
      if (priceEl) {
        priceEl.textContent = priceFormatted;
      } else {
        const addToCartText = window.FoxTheme?.variantStrings?.addToCart || '';
        if (addToCartText) {
          textDesktop.innerHTML = addToCartText + ' <span class="product-card__atc-price">' + priceFormatted + '</span>';
        }
      }
    }
    
    // Update mobile text
    if (textMobile) {
      const priceEl = textMobile.querySelector('.product-card__atc-price');
      if (priceEl) {
        priceEl.textContent = priceFormatted;
      } else {
        const addToCartShortText = window.FoxTheme?.variantStrings?.addToCartShort || '';
        if (addToCartShortText) {
          textMobile.innerHTML = addToCartShortText + ' <span class="product-card__atc-price">' + priceFormatted + '</span>';
        }
      }
    }
  }

  updateButtonForUnavailableVariant(button) {
    button.setAttribute('disabled', 'disabled');
    const textDesktop = button.querySelector('.btn__text--desktop');
    const textMobile = button.querySelector('.btn__text--mobile');
    const soldOutText = window.FoxTheme?.variantStrings?.soldOut || '';
    
    if (textDesktop) {
      textDesktop.innerHTML = soldOutText;
    }
    if (textMobile) {
      textMobile.innerHTML = soldOutText;
    }
  }
}

  customElements.define('product-card-variant-select', ProductCardVariantSelect, { extends: 'select' });
}

